<template>
    <div class="modal fade" id="createModal" tabindex="-1" role="dialog" aria-labelledby="createModalLabel" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{$t('coordinations.edit')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="loader" v-if="isSaving"></div>
                <form @submit="onSubmit" v-show="!isSaving">
                    <div class="modal-body">
                        <!-- <div class="form-group">
                            <label class="font-weight-bold">{{$t('coordinations.coordDoc')}}</label>
                            <div class="w-100">
                                <a :href="link" target="_blank">{{title}}</a>
                            </div>
                        </div>-->
                        <div class="form-group">
                            <div class="font-weight-bold required">{{$t('coordinations.title')}}</div>
                            <div class="w-100">
                                <input class="form-control" v-model="model.title" v-validate="'required'" :name="'title'+_uid" :data-vv-as="$t('coordinations.title')" />
                                <span class="text-danger col-12" v-if="errors.has('title'+_uid)">{{ errors.first('title'+_uid) }}</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="font-weight-bold required">{{$t('request_n')}}</div>
                            <div>
                                <textarea class="form-control w-100" :name="'textarea'+_uid" :data-vv-as="$t('request_n')" v-model="model.request" v-validate="'required'"></textarea>
                                <span class="text-danger col-12" v-if="errors.has('textarea'+_uid)">{{ errors.first('textarea'+_uid) }}</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="font-weight-bold">{{$t('coordinations.requestLink')}}</div>
                            <div>
                                <input class="form-control" type="text" v-model="model.itemLink">
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="font-weight-bold required">{{$t('coordinations.coordinators')}}</div>
                            <Coordinators
                                v-model="model.coordinators"
                                api-url="api/user/searchCoordinators"
                                show-all-users-btn
                            />
                        </div>
                        <div class="form-group">
                            <div class="required font-weight-bold pb-2">{{$t('coordinations.type')}}</div>
                            <div id="task-type-choice">
                                <div class="radio">
                                    <label>
                                        <input type="radio" name="optionsRadios" value="internal" v-model="model.typeId" checked />
                                        {{$t('coordinations.innerType')}}
                                    </label>
                                    <div class="text-info radio-message mb-2" v-if="model.typeId === 'internal'">
                                        <i class="fa fa-exclamation-circle"></i>
                                        {{$t('coordinations.innerTypeMessage')}}
                                    </div>
                                </div>
                                <div class="radio">
                                    <label>
                                        <input type="radio" name="optionsRadios" value="outgoing" v-model="model.typeId" />
                                        {{$t('coordinations.outgoingType')}}
                                    </label>
                                    <div class="text-info radio-message mb-2" v-if="model.typeId === 'outgoing'">
                                        <i class="fa fa-exclamation-circle"></i>
                                        {{$t('coordinations.outgoingTypeMessage')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" v-if="model.typeId === 'outgoing'">
                            <div class="font-weight-bold">{{$t('coordinations.clerk')}}</div>
                            <SearchBox v-model="model.clerkId" :initialValueText="model.clerk" apiUrl="api/user/search" ref="searchbox"></SearchBox>
                        </div>
                        <div class="form-group">
                            <div class="font-weight-bold">{{$t('tasks.deadline')}}</div>
                            <DatePicker v-model="model.deadline"
                                        :min="model.deadline || new Date()"
                                        v-validate="'required'"
                                        :data-vv-as="$t('tasks.deadline')"
                                        :error="errors.first($t('tasks.deadline'))"
                                        :fieldName="$t('tasks.deadline')"></DatePicker>
                        </div>
                        <div class="form-group">
                            <div class="font-weight-bold">{{$t('coordinations.attachments')}}</div>
                            <div>
                                <div class="mb-2" v-for="item in model.attachments" :key="_uid+item.fileName">
                                    <file-crud :file="item"
                                               :showDescription="false"
                                               @removeFile="onRemoveFile"
                                               :editable="!item.id"
                                               :type="item.docTypeCode">
                                    </file-crud>
                                </div>
                                <div v-if="!model.attachments.length || (model.attachments[model.attachments.length-1].content || model.attachments[model.attachments.length-1].id)">
                                    <button class="btn btn-primary ml-0" @click="addAtachment">
                                        <i class="fa fa-plus"></i>
                                        {{$t('add')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary" :disabled="!model.coordinators">{{$t('buttons.save.btnText')}}</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('buttons.cancel')}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Coordinators from './coordinators-list';
    import DatePicker from '../datepicker/DateTimePicker';
    import FileCrud from '../common/FileCRUD';
    import SearchBox from '../common/SearchBox';

    import { Coordination, File } from '@/models/models';
    import coordinationService from '@/services/coordinations.service';

    export default {
        components: {
            Coordinators,
            DatePicker,
            SearchBox,
            FileCrud
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            value: Object
        },
        data() {
            return {
                model: new Coordination(),
                isSaving: false
            };
        },
        methods: {
            onSubmit(e) {
                e.preventDefault();
                if (this.model.coordinators.length) {
                    this.$validator.validate().then(valid => {
                        if (valid) {
                            this.save();
                        } else {
                            console.log('Form not valid');
                        }
                    });
                }
            },
            save() {
                this.isSaving = true;
                let data = new FormData();
                data.append('id', this.model.id);
                data.append('deadline', new Date(this.model.deadline).toJSON());
                data.append('request', this.model.request);
                data.append('title', this.model.title);
                data.append('typeId', this.model.typeId);
                data.append('clerkId', this.model.clerkId);
                data.append('itemLink', this.model.itemLink)

                // coordinators
                for (let index = 0; index < this.model.coordinators.length; index++) {
                    const element = this.model.coordinators[index];
                    if (element.id) {
                        data.append(`coordinators[${index}].id`, element.id);
                    } else {
                        data.append(`coordinators[${index}].userId`, element.userId);
                    }

                    data.append(`coordinators[${index}].sort`, element.sort || index);
                }

                // file
                if (this.model.attachments.length) {
                    for (let index = 0; index < this.model.attachments.length; index++) {
                        const attachment = this.model.attachments[index];
                        if (attachment.id) {
                            data.append(`attachments[${index}].id`, attachment.id);
                        } else {
                            data.append(`files`, attachment.content);
                        }
                    }
                }

                coordinationService
                    .edit(data)
                    .then(result => {
                        this.$vs.notify({
                            color: 'success',
                            title: this.$t('updateSuccess'),
                            text: ''
                        });
                        this.$emit('updated', this.model);
                    })
                    .catch(err => {
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$helpers.errorText(err)
                        });
                    })
                    .then(() => {
                        this.hide();
                    });
            },
            onClose() {
                this.$emit('update:show', false);
                this.$emit('onClose');
                this.isSaving = false;
                this.model = new Coordination();
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            addAtachment() {
                this.model.attachments.push(new File());
            },
            onRemoveFile(_id) {
                this.model.attachments = this.model.attachments.filter(x => x._id !== _id);
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
            $(this.$el).bootstrapMaterialDesign();
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new Coordination(this.value);
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .radio-message {
        padding: 3px 3px 3px 5px;
        border-left: 3px solid #03a9f4;
        box-shadow: 1px 1px 1px 1px lightgrey;
    }

    div.radio label {
        color: inherit;
        cursor: pointer;
    }

    .bmd-form-group {
        padding-top: 1rem !important;
    }
</style>
